/* vue-i18n (version : 8.21.0) */
import Vue from "vue";
import VueI18n from "vue-i18n";

// json 파일을 읽어들이기 위한 function
const requireLang = require.context("@/locales", true, /\.json$/);
const messages = {};

// json file read
for (const file of requireLang.keys()) {
  if (file === "./I18n.js") continue; // .js 파일 제외
  const path = file.replace(/(\.\/|\.json$)/g, "").split("/");
  path.reduce((o, s, i) => {
    if (o[s]) return o[s];
    o[s] = i + 1 === path.length ? requireLang(file) : {};
    return o[s];
  }, messages);
}

Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: localStorage.getItem("defaultLanguage") || "ko",          // 기본 locale
  messages,                                                         // 다국어 메시지
  silentTranslationWarn: true                                       // 메시지 코드가 없을때 나오는 console 경고 off
});

export default i18n;



// WEBPACK FOOTER //
// ./src/locales/I18n.js